import { useEffect, useState } from "react"
import { ApiEndpoints, reqPostNew } from "../../../../../config/apiClient"
import { Spinner } from "react-bootstrap"
import dayjs from "dayjs"

function ClienteUltimasNotas({ empresa, id_cliente }: iProps) {
    const [notas, setNotas] = useState<any[]>([])
    const [notasVazias, setNotasVazias] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        const consultar = async () => {
            const dados = {
                id_empresa: empresa.id_empresa,
                id_cliente: id_cliente
            }
            const api = await reqPostNew(ApiEndpoints.nfseListarUltimasNotas, dados)
            setLoading(false)
            if (api.status === 200) {
                const notasAux: any[] = api.data
                if (notasAux.length === 0) {
                    setNotasVazias(true)
                }
                setNotas(notasAux)
            }
        }
        consultar()
        // eslint-disable-next-line
    }, [])

    return (
        <div>
            {loading && <Spinner></Spinner>}
            <div className="div-row" style={{ margin: "10px 0px" }}>
                {
                    notas.map((nota: any, idx: number, arr: any[]) => {
                        return (
                            <div key={idx} style={{ marginRight: "10px" }}>
                                <a href={`${ApiEndpoints.apiNew}/nfse/danfse/view/${nota.id_chave}`} className="div-row" target="_blank" rel="noreferrer" style={{ textDecoration: "none", margin: "0px", padding: "5px", border: "1px solid grey", borderRadius: "5px" }}>
                                    <span className="material-symbols-outlined" style={{ fontSize: '20px', color: 'blue' }}>
                                        visibility
                                    </span>
                                    <p style={{marginLeft: "5px", color: "black"}}>NFS {dayjs(nota.dps_data_competencia).format("DD/MM/YYYY")} - R$ {nota.valor_servicos}</p>
                                </a>
                            </div>
                        )
                    })
                }
            </div>
            {notasVazias && <p style={{marginBottom: "10px"}}>Nenhuma nota emitida.</p>}
        </div>
    )
}
interface iProps {
    empresa: any
    id_cliente: number
}

export default function ClienteUltimasNotasEmitidas({ empresa, id_cliente, carregarNotas, handleCarregarNotas }: iPropsContainer) {
    if (id_cliente === 0) {
        return (<div></div>)
    }
    return (
        <div>
            <div className="div-row" style={{ width: "max-content", cursor: "pointer", alignItems: "center", marginTop: "10px" }} onClick={() => { handleCarregarNotas(!carregarNotas) }}>
                <span className="material-symbols-outlined" style={{ fontSize: '20px', marginRight: "5px" }}>
                    {!carregarNotas ? "visibility" : "visibility_off"}
                </span>
                <p>Visualizar ultimas notas emitidas</p>
            </div>
            {/*{!carregarNotas && <br></br>}*/}

            {carregarNotas && <ClienteUltimasNotas empresa={empresa} id_cliente={id_cliente} />}
        </div>
    )
}
interface iPropsContainer {
    empresa: any
    id_cliente: number
    carregarNotas: boolean
    handleCarregarNotas: any
}
